import React from 'react'
import EditViewIndividualMemberForm from '../../features/ViewIndividualMemberForm/EditViewIndividualMemberForm'

const EditViewIndividualMember = () => {
  return (<EditViewIndividualMemberForm />)
}

export default EditViewIndividualMember
